import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/client-voucher-details/AppDetails'

// helpers
import Axios from 'src/helpers/axios'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ClientVoucherDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [clientVoucherDetails, setClientVoucherDetails] = useState('')

  const handleCardHeaderButton = () => {
    navigate(`/client-voucher/edit/${id}`)
  }

  useEffect(() => {
    fetchClientVoucherDetails()
  }, [id]);

  const fetchClientVoucherDetails = () => {
    Axios({
      method: "get",
      url: `/api/gamepass/v1/voucher/client/detail/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClientVoucherDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/client-voucher/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Client Voucher Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            clientVoucherDetails={clientVoucherDetails}
          />
        }
      />
    </>
  )
}

export default ClientVoucherDetails
